<template>
  <UIButton ref="buttonRef" :label :trailing="short ? CheckIcon : undefined" class="ui-button-save" :class="classes" />
</template>

<script setup lang="ts">
import { computed, useTemplateRef } from 'vue'

import { UIButton } from '@ui/buttons'
import { CheckIcon } from '@heroicons/vue/24/outline'

type Props = {
  label?: string
  short?: boolean
  unlabeled?: boolean
}

const props = defineProps<Props>()

const buttonRef = useTemplateRef('buttonRef')

defineExpose({
  focus() {
    buttonRef.value?.focus()
  },
})

const label = computed(() => props.short ? undefined : props.label || 'Save')

const classes = computed(() => ({
  'ui-button-save--short': props.short,
}))
</script>

<style>
.ui-button-save {
  @apply min-w-28;

  &--short {
    @apply min-w-0;
  }
}
</style>
